<!--
 * @Author: wumao
 * @Date: 2021-11-24 16:15:02
 * @LastEditors: yeqing
 * @LastEditTime: 2022-05-13 15:41:25
 * @Description: 第一页
-->
<template>
  <Page :page="city == 'Hainan' ?'04':'01'" :companyName="resultData.orgName">
    <div class="wrapper">
      <div class="item">
        <Title text="测评企业基本信息"  v-if="city == 'Hainan'"/>
        <Title :text="resultData.orgName"  v-else />
        <div class="info">
          <div class="line" v-if="city == 'Hainan'">
            <!-- <span>成立时间：</span> -->
            <span>{{ resultData.orgName }}</span>
            <span></span>
          </div>
          <div class="line">
            <span>成立时间：</span>
            <span>{{ resultData.regTime }}</span>
          </div>
          <div class="line" v-if="city == 'Hainan'">
            <span>统一社会信息代码: </span>
            <span>{{ resultData.socialCreditCode }}</span>
          </div>
           <div class="line" v-if="city == 'Hainan'">
            <span>地址: </span>
            <span>{{ resultData.regLocation }}</span>
          </div>
          <div class="line">
            <span>主要产品(服务)所属国家高新技术领域：</span>
            <span>{{ resultData.mainProducts }}</span>
          </div>
        </div>
      </div>
      <div class="item">
        <Title text="综合测评结果" />
        <div class="area">
          <div class="icon">
            <img
              v-if="resultData.result.accord == 1"
              src="@/assets/images/dabiao.png"
              alt=""
            />
            <img v-else src="@/assets/images/budabiao.png" alt="" />
          </div>
          <p>{{ resultData.result.descriptionResult }}</p>
        </div>
      </div>

      <div class="item" v-if="resultData.suggest.length">
        <Title
          v-if="resultData.result.accord == 1"
          text="需提升方面及建议方案"
        />
        <Title v-else text="未达标原因及解决方案" />
        <div class="area-border">
          <div
            v-for="(item, index) in resultData.suggest"
            :key="index"
            class="item-raw"
          >
            <div class="analysis">
              <span class="num">{{ index + 1 }}.</span>
              <span class="text">{{ item.analysis }}</span>
            </div>
            <div class="suggest">
              <span class="num">建议方案：{{ item.suggest }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Page>
</template>

<script>
import Page from "./Page.vue";
import Title from "./Title.vue";
export default {
  props: {
    resultData: {
      type: Object,
      default: () => {},
    },
    city: String
  },
  components: {
    Page,
    Title,
  },
};
</script>

<style lang="less" scoped>
.wrapper {
  .item {
    font-size: 14px;
    color: #333;
    margin-bottom: 30px;
    .info {
      margin-left: 20px;
      margin-top: 30px;
      .line {
        line-height: 30px;
        span:last-child {
          color: #666;
        }
      }
    }
    .area {
      margin-top: 30px;
      width: 100%;
      padding: 40px;
      background: #f7fafe;
      color: #333;
      .icon {
        width: 105px;
        height: 92px;
        margin: 0 auto 10px;
        overflow: hidden;
        img {
          width: 100%;
          height: 100%;
        }
      }
      p {
        line-height: 26px;
      }
    }
    .area-border {
      margin-top: 30px;
      padding: 35px 30px 30px 30px;
      color: #333;
      border: 1px solid #f0f0f0;
      .item-raw {
        margin-bottom: 30px;
        .analysis {
          margin-bottom: 10px;

          display: flex;
          .num {
            flex-shrink: 0;
          }
        }
        .suggest {
          margin-bottom: 0;
          color: #a77123;
        }
      }
    }
  }
}
</style>
